import { render, staticRenderFns } from "./talentCites.vue?vue&type=template&id=303466ee&scoped=true"
import script from "./talentCites.vue?vue&type=script&lang=js"
export * from "./talentCites.vue?vue&type=script&lang=js"
import style0 from "./talentCites.vue?vue&type=style&index=0&id=303466ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303466ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303466ee')) {
      api.createRecord('303466ee', component.options)
    } else {
      api.reload('303466ee', component.options)
    }
    module.hot.accept("./talentCites.vue?vue&type=template&id=303466ee&scoped=true", function () {
      api.rerender('303466ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/talentCites.vue"
export default component.exports